define('drops/dropDown_v2/dropDown_v2',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq/util',
    'underscore',
    'lq/tooltip',
    'lq/html',
    'lq/required',
    'drops/modals',
    './dropkick'
], function ($, Drop, Style, util, _, Tooltip, html, Required, modals) {
    'use strict';

    var defaults = {
        data: {
            showEmptyItem: true,
            hideEmptyItemInList: false,
            title: {
                option: Tooltip.hardcoded
            },
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            }
        }
    };

    function Dropdown(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing);
        this.loaded = false;
        this.value = null;
        this.valueIsNumber = false;

        this.$element
            .addClass('boxToBorderSize')
            .css({
                whiteSpace: 'pre-wrap'
            });

        var self = this;
        this.$dropDown = $('<select />')
            .css({
                width: '100%',
                height: '100%'
            })
            .on('change', this.valueChanged.bind(this))
            .attr('tabindex', self.data.tabIndex)
            .append($('<option>'))
            .appendTo(self.$element);

        if (this.data.readOnly)
            this.$dropDown.prop('disabled', true);

        this.onScroll = this.handleScroll.bind(this);
        this.onChange = this.handleChange.bind(this);

        this.$dropDown.on('change', this.onChange);

        this.tooltip = new Tooltip(this, this.data.title, this.$dropDown);
    };

    Drop.extend(Dropdown, Drop);

    Dropdown.typeName = 'Dropdown_v2';

    Dropdown.prototype.handleChange = function() {
        if (this.$dropDown.val()) {
            var arg = this.$dropDown.val();
            this.triggerEventIfEnabled('selected', arg);
            this.triggerEventIfEnabled('changed', arg);
        } else {
            this.triggerEventIfEnabled('deselected', null);
            this.triggerEventIfEnabled('changed', null);
        }

        this.updateRequiredIndicator();
    };

    Dropdown.prototype.preRender = function () {
        var self = this;
        this.tooltip.update();
        this.piping.visibility.apply(this);
        this.piping.required.apply(this);
        this.piping.datasources.registerDatasourceListener(
            this.data.dataSource,
            function (data) { self._update(data); },
            function (params) {
                if (self.data.pageSize) {
                    params.pageSize = self.data.pageSize;
                }
            });
        Required.prototype.addRemoveRequiredIndicator(self);

        this.applyPosition();
        this.renderMockData();
    };

    Dropdown.prototype.postRender = function() {
        var self = this;
        this.dropKickObject = new Dropkick(this.$dropDown[0],
            {
                initialize: function () {
                    Style.renderStyles(self, null, $(this.data.optList));
                },
                mobile: true,
                change: $.noop,
                open: function () {
                    var css = {};
                    css.zIndex = modals.getZIndexForPopups();

                    if (self.data.listMaxHeight)
                        css.maxHeight = self.data.listMaxHeight + 'px';

                    $(self.dropKickObject.data.optList)
                        .css(css);

                    if ($(window).height() < (parseInt($(self.dropKickObject.data.optList).css('top')) + $(self.dropKickObject.data.optList).outerHeight())) {
                        $(self.dropKickObject.data.optList).css({top: (parseInt($(self.dropKickObject.data.optList).css('top')) - self.$dropDown.outerHeight() - $(self.dropKickObject.data.optList).outerHeight()) + 'px'});
                        self.listPosition = 'Top';
                    } else {
                        self.listPosition = 'Bottom';
                    }
                },
                close: $.noop,
                search: "strict",
                bubble: true
            });
        this.$dkSelected = this.$element.find('.dk-selected')
            .addClass('dropdown-stylable-placeholder');

        if (this.data.hideEmptyItemInList && this.data.showEmptyItem)
            $(this.dropKickObject.data.optList).addClass('empty-item-hidden');

        this.piping.$actionWrapper.on('scroll', this.onScroll);
        $(window).resize(this.rootDrop.$container, function () {
            var top = $(self.dropKickObject.data.optList).css('top');
            if (($(window).height() < ($(self.$dropDown[0].parentNode).offset().top + $(self.$dropDown[0].parentNode).height() + $(self.dropKickObject.data.optList).outerHeight()) && self.listPosition === 'Bottom')) {
                self.listPosition = 'Top';
                top = (parseInt($(self.dropKickObject.data.optList).css('top')) - self.$dropDown.outerHeight() - $(self.dropKickObject.data.optList).outerHeight()) + 'px';
            } else if (($(window).height() > ($(self.$dropDown[0].parentNode).offset().top + $(self.$dropDown[0].parentNode).height() + $(self.dropKickObject.data.optList).outerHeight()) && self.listPosition === 'Top')) {
                self.listPosition = 'Bottom';
                top = $(self.$dropDown[0].parentNode).offset().top + $(self.$dropDown[0].parentNode).height();
            }
            $(self.dropKickObject.data.optList).css({
                zIndex: 7001,
                position: 'absolute',
                width: parseInt($(self.$dropDown[0].parentNode).css('width')) - 2 + 'px',
                left: $(self.$dropDown[0].parentNode).offset().left,
                top: top
              });
        });

        Style.renderStyles(this, null, this.$dkSelected);
    };

    Dropdown.prototype.handleScroll = function () {
        this.dropKickObject.funcs.close.apply(this.dropKickObject);
    };

    Dropdown.prototype.valueChanged = function() {
        var val = this.$dropDown.val();
        this.value = val === '' ? null : val;

        Style.renderStyles(this, null, this.$dkSelected);

        if (!this.value) {
            this.$dkSelected.addClass('dropdown-stylable-placeholder');
        } else {
            this.$dkSelected.removeClass('dropdown-stylable-placeholder');
        }
    };

    Dropdown.prototype.createEmptyItem = function() {
        return $('<option />', { value: '', text: this.data.emptyItemText || '...' })
            .css({display: 'none'});
    };

    Dropdown.prototype.renderMockData = function () {
        if (this.data.showEmptyItem)
            this.$dropDown.append(this.createEmptyItem());

        if (!this.data.mockData) return;
        this.$dropDown.children(':first').remove();
        this.$dropDown.append(_.map(this.data.mockData.split('\n'), function(item) {
            return $('<option />', {
                value: item,
                text: item
            });
        }));
    };

    Dropdown.prototype._update = function (data) {
        this.loaded = true;

        this.$dropDown
            .find('option')
            .remove()
            .end();

        if (this.data.showEmptyItem)
            this.$dropDown.append(this.createEmptyItem());

        var self = this;
        $.each(data.Results, function (key, result) {
            var val = result[self.data.selectedKeyColumn || 'Id'];
            self.valueIsNumber = (typeof val === 'number');
            $('<option />', {
                value: val,
                text: html.strip(self.getDisplayStringFromResult(result))
            })
            .appendTo(self.$dropDown);
        });

        this.dropKickObject.refresh();

        this.$dkSelected = this.$element.find('.dk-selected');

        if (this.data.hideEmptyItemInList && this.data.showEmptyItem)
            $(this.dropKickObject.data.optList).addClass('empty-item-hidden');

        Style.renderStyles(this, null, this.$dkSelected);

        if (this.value)
            this.setValue({ value: this.value });
        else if (this.data.showEmptyItem) {
            this.$dkSelected.addClass('dropdown-stylable-placeholder');
        } else {
            this.selectFirstItem();
        }
    };

    Dropdown.prototype.getDisplayStringFromResult = function (result) {
        var column = this.getNameOfDisplayedColumn(result);
        return result[column];
    };

    Dropdown.prototype.getNameOfDisplayedColumn = function (result) {
        var keys = Object.keys(result);
        if (keys.length === 1) {
            return keys[0];
        }
        if (keys.indexOf(this.data.selectedColumnToShow) !== -1) {
            return this.data.selectedColumnToShow;
        }
        if (keys[0].toUpperCase() !== "ID") {
            return keys[0];
        }
        return keys[1];
    };

    Dropdown.prototype.focus = function () {
        this.$dropDown.trigger('focus');
    };

    Dropdown.prototype.getValue = function () {
        if (this.valueIsNumber && this.value !== null)
            return parseInt(this.value);
        return this.value === undefined
            ? null
            : this.value;
    };

    Dropdown.prototype.clearValue = function () {
        if (this.data.showEmptyItem) {
            this.value = null;
        }
        this.selectFirstItem();
        this.updateRequiredIndicator();
    };

    Dropdown.prototype.selectFirstItem = function () {
        this.dropKickObject.select(0);
        this.valueChanged();
    };

    Dropdown.prototype.setValue = function (update) {
        if (!this.loaded) {
            this.value = update.value;
        } else {
            if (update.value !== null && update.value !== undefined) {
                var option = _.find(this.$dropDown.children(), function(option) {
                    return option.value === update.value.toString();
                });

                if (option) {
                    this.value = update.value;
                    this.dropKickObject.select(update.value.toString());
                    this.updateRequiredIndicator();
                } else {
                    this.triggerEventIfEnabled('valueNotFound', update.value);
                    if(!this.isEventEnabled('valueNotFound')) {
                        alert('A value was mapped onto a drop down list, but the corresponding item was not found in the list. Saving this form will cause you to lose this information.');
                    }

                    this.clearValue();
                }
            } else {
                this.clearValue();
            }
        }
        this.updateRequiredIndicator();
    };

    Dropdown.prototype.unsubscribeEventHandlers = function () {
        this.$dropDown.off('change', this.onChange);
        this.piping.$actionWrapper.off('scroll', this.onScroll);

    };

    return Dropdown;
});
